import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardHeader, CardBody, Table, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, Button } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import { Accordion } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const Inventory = (props) => {
  const LargeModaltoggle = () => {
    setInventory_qty("")
    setInventory_Units("")
    setInventory_costperunit("")
    setInventory_type("")
    setInventory_sold("")
    setLarge(!Large)
  };
  const [edittype, setedittype] = useState("")
  const [editid, seteditid] = useState("")
  const [Large, setLarge] = useState(false);
  const [inventory_qty, setInventory_qty] = useState('')
  const [inventory_costperunit, setInventory_costperunit] = useState('')
  const [inventory_units, setInventory_Units] = useState('')
  const [inventory_sold, setInventory_sold] = useState('')
  const [inventory_type, setInventory_type] = useState('')

  const [Inventorytype, setInventorytype] = useState([])
  const [clientHeight, setclientHeight] = useState("")

  const [Inventory_detail, setInventory_detail] = useState([])


  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
  useEffect(() => {
    if (localStorage.getItem("usertype") !== "Supplier") {
      window.history.back()
    }



    getInventorytype()


    getInventorydetail()
  }, [])
  async function getInventorytype() {
    let { data: inventory_type, error } = await supabase
      .from('inventory_type_details')
      .select('*')

    if (error === null) {

      setInventorytype(inventory_type)
    }

  }

  async function getInventorydetail() {
    let { data: Inventory_Details, error } = await supabase
      .from('inventory_details')
      .select('*')
      .eq("created_By", localStorage.getItem("useremail"))

    if (Inventory_Details !== null && Inventory_Details.length > 0) {
      setInventory_detail(Inventory_Details)
    } else {
      // toast.error("No Inventory Details Found")
      setInventory_detail([])
    }
  }

  const randomUsername = () => {
    return `${Date.now().toString().substr(-4)}`;
  };
  const UpdateUser = async (Inventoryid) => {
    setLarge(!Large)
    setedittype("updated")
    seteditid(Inventoryid)
    let { data: Inventory_Details, error } = await supabase
      .from('inventory_details')
      .select('*')
      .eq('inventory_id', Inventoryid)

    if (Inventory_Details !== null && Inventory_Details.length > 0) {
      setInventory_qty(Inventory_Details[0].inventory_quantity)
      setInventory_Units(Inventory_Details[0].inventory_units)
      setInventory_costperunit(Inventory_Details[0].inventory_costperunit)
      setInventory_type(Inventory_Details[0].inventory_type)
      setInventory_sold(Inventory_Details[0].inventory_sold)

    }
  }
  const DeleteUser = async (Inventoryid) => {



    let { data: Inventory_Details, error } = await supabase
      .from('inventory_details')
      .delete()
      .eq('inventory_id', Inventoryid)

    if (Inventory_Details !== null && Inventory_Details.length > 0) {

      toast.success("Inventory Deleted Successfully")
      getInventorydetail()


    } else {
      toast.error("Error in Deleting Inventory")
    }

  }
  const RegisterUser = async (type, id) => {

    if (type == "new") {
      var inventory_id = `Inventory${randomUsername()}`

      const { data, error } = await supabase
        .from('inventory_details')
        .insert([
          { inventory_id: inventory_id, created_By: window.localStorage.getItem("useremail"), inventory_quantity: parseInt(inventory_qty), inventory_sold: parseInt(inventory_sold), inventory_units: inventory_units, inventory_type: inventory_type, inventory_costperunit: parseFloat(inventory_costperunit) },
        ])

      if (data !== null) {


        toast.success(`Inventory Created Successfully`)
        setLarge(!Large)
        getInventorydetail()


      } else {
        toast.error(error.message)
      }

    } else {
      var inventory_id = id

      const { data, error } = await supabase
        .from('inventory_details')
        .update(
          { created_By: window.localStorage.getItem("useremail"), inventory_quantity: parseInt(inventory_qty), inventory_sold: parseInt(inventory_sold), inventory_units: inventory_units, inventory_type: inventory_type, inventory_costperunit: parseFloat(inventory_costperunit) },
        )
        .eq('inventory_id', inventory_id)

      if (data !== null) {


        toast.success(`Inventory Updated Successfully`)
        setLarge(!Large)
        getInventorydetail()


      } else {
        toast.error(error.message)
      }

    }



  }
  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Inventory Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
              <ModalHeader toggle={LargeModaltoggle}>
                {edittype == "new" ? "Add" : "Update"} Here For Inventory
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Inventory Type<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">

                        <Input className="form-control" type="select" value={inventory_type} onChange={(e) => {
                          setInventory_type(e.target.value)
                        }}>
                          <option value={""}>Choose Your Inventory Type</option>
                          {Inventorytype.map((data, i) => {

                            return (
                              <option key={i} value={data.inventory_type}>{data.inventory_type}</option>
                            )
                          })}
                        </Input>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Inventory Quantity<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder="Enter Inverntory Quantity" value={inventory_qty} onChange={(e) => { setInventory_qty(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Sold Inventory<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder="Enter Your Sold Inventory" value={inventory_sold} onChange={(e) => { setInventory_sold(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Inventory Units<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control digits" type="select" value={inventory_units} onChange={(e) => { setInventory_Units(e.target.value) }} >
                          <option value={""}>Choose Your Inventory Units</option>


                          <option value={"Pcs"}>Pcs</option>
                          <option value={"Ton"}>Ton</option>
                        </Input>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label"> Inventory Cost Per Unit<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder='Enter Your Inventory cost Per unit' value={inventory_costperunit} onChange={(e) => { setInventory_costperunit(e.target.value) }} />
                      </Col>
                    </FormGroup>




                    <FormGroup className="mb-0 mt-3">


                      <Button color="primary" className="btn-block" onClick={() => {
                        RegisterUser(edittype, editid)
                      }}>PROCEED </Button>
                    </FormGroup>






                  </Col>
                </Row>
              </ModalBody>
            </Modal>
            {window.innerWidth < 800 ? <>
              <div style={{ textAlign: "right",padding:"5px" }}>
                <button className='btn' style={{ fontSize: "13px", padding: "10px", boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)", borderRadius: "10px", backgroundColor: "#E50014", color: "white" }} onClick={() => {
                  LargeModaltoggle(); setedittype("new")
                  seteditid("")
                }}>Create Inventory</button>
              </div>

              <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll", padding: "5px" } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">

                    {Inventory_detail.length > 0 ? <>
                      {Inventory_detail.map((data, i) => {
                        return (
                          <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                            <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                              <h5 className="mb-0" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>
                                      {/* <div className="media-size-email"><img src={data.vehicle_pic} alt="buyer_image" height={"40px"} width={"40px"} style={{ borderRadius: "10px" }} />
                                      </div> */}
                                      <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>

                                        <span style={{ display: "block" }}>{data.inventory_type}</span>
                                        <span style={{ display: "block" }}>{data.inventory_quantity} {data.inventory_type == "Bricks"?"Pcs":"Ton"}</span>

                                      </div>


                                    </div>
                                  </div>



                                </Accordion.Toggle>
                                <div className="media-size-email" style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#dfffe4", padding: "5px", cursor: "pointer" }} onClick={() => {
                                  UpdateUser(data.inventory_id)
                                }}><Icon icon="bxs:edit" color="darkgreen" width="30" height="30" /></div>
                                  &nbsp;
                                  <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#efc6ca", padding: "5px", cursor: "pointer" }} onClick={() => {
                                    DeleteUser(data.inventory_id)
                                  }}><Icon icon="bi:trash" color="#E50014" width="25" height="25" /></div>



                                </div>
                              </h5>
                            </CardHeader>
                            <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                              <CardBody>
                                <div className="email-app-sidebar left-bookmark">
                                  <div className="media" >

                                    <div className="media-body" style={{ textAlign: "left" }}>
                                     
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Sold Inventory</span>
                                      <span style={{ display: "block" }}>{data.inventory_sold}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Inventory Unit</span>
                                      <span style={{ display: "block" }}>{data.inventory_units}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Cost Per Unit</span>
                                      <span style={{ display: "block" }}>{data.inventory_costperunit}</span>


                                    </div>
                                    {/* <div className="media-body" style={{ textAlign: "left" }}>
                                      
                                     


                                    </div> */}


                                  </div>


                                </div>


                              </CardBody>
                            </Accordion.Collapse>
                          </Card>
                        )


                      })}</> : <Card>
                      <CardHeader >
                        <h5 className="mb-0">
                          <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                            No Record Found
                          </Accordion.Toggle>
                        </h5>
                      </CardHeader>
                    </Card>}
                  </div>

                </Accordion>
              </div></> :
            <Card>
              <CardHeader>
                <button className='btn btn-primary' style={{ float: "right" }} onClick={() => {
                  LargeModaltoggle(); setedittype("new")
                  seteditid("")
                }}>Create Inventory</button>

              </CardHeader>
              <CardBody>
                <div className="table-responsive ">
                  <Table>
                    <thead>
                      <tr style={{ textAlign: "center" }}>
                        <th scope="col">{"Sr.No"}</th>
                        <th scope="col">{"Inventory Type"}</th>
                        <th scope="col">{"Inventory Quantity"}</th>
                        <th scope="col">{"Sold Inventory"}</th>
                        <th scope="col">{"Inventory Units"}</th>
                        <th scope="col">{"Inventory Cost Per Unit"}</th>
                        <th scope="col">{"Action"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Inventory_detail.length > 0 ? <>
                        {Inventory_detail.map((data, i) => {
                          return (
                            <tr key={i} style={{ textAlign: "center" }}>
                              <th scope="row">{i + 1}</th>
                              <td>{data.inventory_type}</td>
                              <td>{data.inventory_quantity}</td>
                              <td>{data.inventory_sold}</td>
                              <td>{data.inventory_units}</td>
                              <td>{data.inventory_costperunit}</td>
                              <td><button className='btn btn-warning' onClick={() => {
                                UpdateUser(data.inventory_id)
                              }}><i className='fa fa-edit '></i></button> &nbsp;<button className='btn btn-danger' onClick={() => {
                                DeleteUser(data.inventory_id)
                              }}><i className='fa fa-trash'></i></button></td>
                            </tr>
                          )
                        })}
                      </>
                        : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}
                      {/* <tr style={{textAlign:"center"}}>
                      <th scope="row">{"1"}</th>
                      <td>{"Alexander"}</td>
                      <td>{"Orton"}</td>
                      <td>{"@mdorton"}</td>
                      <td>{"Admin"}</td>
                      <td>{"USA"}</td>
                    </tr> */}

                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>}

          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default Inventory;